var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconMarketing(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.99995 5.40078C11.2702 5.40078 12.3 4.37103 12.3 3.10078C12.3 1.83053 11.2702 0.800781 9.99995 0.800781C8.72971 0.800781 7.69995 1.83053 7.69995 3.10078C7.69995 4.37103 8.72971 5.40078 9.99995 5.40078Z",
    stroke: "#474545",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fill: "none"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.99995 19.2016C11.2702 19.2016 12.3 18.1718 12.3 16.9016C12.3 15.6313 11.2702 14.6016 9.99995 14.6016C8.72971 14.6016 7.69995 15.6313 7.69995 16.9016C7.69995 18.1718 8.72971 19.2016 9.99995 19.2016Z",
    stroke: "#474545",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fill: "none"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.39999 7.69922H0.799988V12.2992H5.39999V7.69922Z",
    stroke: "#474545",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fill: "none"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M19.2 7.69922H14.6V12.2992H19.2V7.69922Z",
    stroke: "#474545",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fill: "none"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M7.69998 3.10156H4.14129C3.56619 3.10156 3.09998 3.56777 3.09998 4.14288V7.70156",
    stroke: "#474545",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fill: "none"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M7.69998 16.9008H4.14129C3.56619 16.9008 3.09998 16.4346 3.09998 15.8595V12.3008",
    stroke: "#474545",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fill: "none"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M12.3 3.10156H16.3187C16.8938 3.10156 17.36 3.56777 17.36 4.14288V7.70156",
    stroke: "#474545",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fill: "none"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M12.3 16.9008H15.8587C16.4338 16.9008 16.9 16.4346 16.9 15.8595V12.3008",
    stroke: "#474545",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fill: "none"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMarketing);
export default __webpack_public_path__ + "static/media/icon-marketing.aa092708.svg";
export { ForwardRef as ReactComponent };